import 'src/assets/css/index.css';
import 'src/i18n';
import 'typeface-montserrat/index.css';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { GlobalLoadingIndicator } from 'src/components/loadingIndicators/LoadingGlobalIndicator';
import { AuthProvider } from 'src/components/providers/AuthProvider';
import { SplashScreen } from 'src/components/splashes/SplashScreen';
import { ThemeProvider } from 'src/providers/ThemeProvider';
import { reportWebVitals } from 'src/reportWebVitals';
import { router } from 'src/routes/router';
import { trace } from 'src/tracing';

trace(router);

const rootElement = document.querySelector('[role=application]');

if (!rootElement) {
  throw new Error('Application root element was not found.');
}

const root = createRoot(rootElement, {
  onRecoverableError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

root.render(
  <StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <NuqsAdapter>
          <QueryClientProvider client={queryClient}>
            <GlobalLoadingIndicator />
            <Suspense
              fallback={
                <SplashScreen
                  loadingLabel='Loading...'
                  title='Demand planning'
                />
              }
            >
              <RouterProvider router={router} />
            </Suspense>
          </QueryClientProvider>
        </NuqsAdapter>
      </ThemeProvider>
    </AuthProvider>
  </StrictMode>,
);

reportWebVitals(console.info);
